var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("print-browse")) + " "),
          _c("w-progress-linear", {
            staticClass: "full inTitle",
            model: {
              value: _vm.progressValue,
              callback: function ($$v) {
                _vm.progressValue = $$v
              },
              expression: "progressValue",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(" " + _vm._s(_vm.progressText) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }